import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useTitle } from '@vueuse/core'
import { computed, onMounted } from 'vue'
import { __ } from './locales'
import { useStoreAuth } from './store/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const storeAuth = useStoreAuth()

onMounted(async () => {
  const preload = document.querySelector('#preload')
  preload?.remove()
})

const title = computed(
  () => `${__('Nav.title')} - ${__(`Nav.${storeAuth.currentPage}`)}`,
)
useTitle(title)

return (_ctx: any,_cache: any) => {
  const _component_dig_ui_toaster = _resolveComponent("dig-ui-toaster")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dig_ui_toaster, { bottom: "" }),
    _createVNode(_component_router_view)
  ], 64))
}
}

})